import { supabase } from "../integrations/supabase/client";

/**
 * Gets the current user ID from Supabase auth
 * @returns The user ID as a string
 * @throws Error if no user is authenticated
 */
export async function getCurrentUserId(): Promise<string> {
  const {
    data: { user },
  } = await supabase.auth.getUser();

  if (!user) {
    console.warn("No authenticated user found");
    throw new Error("User not authenticated");
  }

  return user.id;
}

/**
 * Checks if a user is currently authenticated
 * @returns True if a user is authenticated, false otherwise
 */
export async function isAuthenticated(): Promise<boolean> {
  try {
    const {
      data: { user },
    } = await supabase.auth.getUser();
    return !!user;
  } catch (error) {
    console.error("Error checking authentication:", error);
    return false;
  }
}

/**
 * Gets the current user ID if authenticated, otherwise returns null
 * @returns The user ID as a string or null if not authenticated
 */
export async function getCurrentUserIdSafe(): Promise<string | null> {
  try {
    const {
      data: { user },
    } = await supabase.auth.getUser();
    return user?.id || null;
  } catch (error) {
    console.error("Error getting user ID:", error);
    return null;
  }
}
